import Cookies from "js-cookie";
import { PASSIO_MAIN_DOMAIN } from "../configs/system";

export const getHostName = () => window.location.hostname;

export const originDomain = () => {
    const hostName = getHostName();
    const hostNamePassio = hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1);
    if (hostNamePassio === PASSIO_MAIN_DOMAIN) {
      return hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1);
    } 
    return hostName
};
